export const hubspotFormConfigs = {
  contactUs: {
    portalId: '48395310',
    formId: 'df0f96bc-8082-4422-b513-0c5ff8aa5853',
    additionalOptions: {},
  },
};

/**
 * An object mapping supported HubSpot prefill fields to their corresponding keys.
 * These fields are used to prefill form data in HubSpot forms.
 *
 * {
 *   {Hubspot form field name}: {UserContext property name},
 * }
 */
export const supportedHubspotPrefillFields = {
  email: 'email',
  firstname: 'firstName',
  lastname: 'lastName',
};
